<div class="card-marketing-container">
    @if (imageSrc) {
        <div class="image">
            <img class="marketing-image" [src]="imageSrc" alt="marketing-image"/>
        </div>
    }
    @if (hasCustomTemplate(headerTemplate) || hasCustomTemplate(bodyTemplate) || hasCustomTemplate(footerTemplate)) {
        <div class="content">
            @if (hasCustomTemplate(headerTemplate)) {
                <div class="header">
                    <ng-container>
                        <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
                    </ng-container>
                </div>
            }
            @if (hasCustomTemplate(bodyTemplate)) {
                <div class="body">
                    <ng-container>
                        <ng-container *ngTemplateOutlet="bodyTemplate"></ng-container>
                    </ng-container>
                </div>
            }
            @if (hasCustomTemplate(footerTemplate)) {
                <div class="footer">
                    <ng-container>
                        <ng-container *ngTemplateOutlet="footerTemplate"></ng-container>
                    </ng-container>
                </div>
            }
        </div>
    }
</div>
